import React from "react";
import { logAdminDiagnostic } from "../utils/clientDiagnostics";

export default class AppErrorBoundary extends React.Component {
  state = { hasError: false };
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(error, info) {
    console.error("Frontend render error:", error, info);
    logAdminDiagnostic("pwa-lifecycle", {
      phase: "render-error",
      errorName: error?.name || "Error",
      errorMessage: error?.message || "Unknown render error",
      componentStack: info?.componentStack || "",
    });

    if (
      /ChunkLoadError|Loading chunk|dynamically imported module/i.test(
        `${error?.name || ""} ${error?.message || ""}`,
      )
    ) {
      window.setTimeout(() => {
        window.__cinemaRecover?.("chunk-load-error", false);
      }, 250);
    }
  }
  render() {
    if (!this.state.hasError) return this.props.children;
    return <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#111", color: "white", textAlign: "center", padding: 24 }}><div><h2>เกิดข้อผิดพลาดในการแสดงหน้าเว็บ</h2><p>ระบบจะล้างไฟล์เก่าและโหลดเวอร์ชันล่าสุดให้</p><button type="button" onClick={() => window.__cinemaRecover?.("render-error", true)} style={{ minHeight: 48, marginTop: 16, padding: "0 24px", border: 0, borderRadius: 14, background: "linear-gradient(135deg,#e5312a,#f8a928)", color: "white", fontWeight: 800 }}>กู้คืนและโหลดใหม่</button></div></div>;
  }
}
